module.exports = __webpack_public_path__ + "static/media/Cross.e83890f8.svg";